// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Utils
import { isOnboardingFlowError } from '../../utils/error.utils';

const isReloadError = (error: AppErrorEnumeration): boolean =>
  [
    AppErrorEnumeration.CHECKOUT_NO_INFO,
    AppErrorEnumeration.STATE_FAILED,
    AppErrorEnumeration.UNKNOWN_ERROR,
  ].includes(error);

const shouldReloadPage = (error: AppErrorEnumeration): boolean =>
  isReloadError(error) || isOnboardingFlowError(error);

export { isReloadError, shouldReloadPage };
